export const CArticleListingFragments = {
  field: `
    fragment articleListing on articleListing_MatrixField {
      ... on articleListing_block_Entry {
        id
        typeHandle
        idName
        trendingArticles {
          id
          title
          typeHandle
          uri
          ... on testimonialPages_Entry {
            testimonialOccupation
            image: testimonialImage {
              url @transform(mode: "crop", width: 600, immediately: true)
              title
            }
          }
          ... on blog_Entry {
            image: blogImage {
              url @transform(mode: "crop", width: 600, immediately: true)
              title
            }
          }
          ... on legacyBlog_Entry {
            image: blogImage {
              url @transform(mode: "crop", width: 600, immediately: true)
              title
            }
          }
        }
      }
    }
  `,
}
